"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgScissorsCut02 = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.957 9.44a4 4 0 1 1 4.226-.087l2.996 1.525 9.367-4.769a1 1 0 1 1 .908 1.782L13.384 12l8.07 4.109a1 1 0 1 1-.908 1.782l-9.367-4.769-2.996 1.526a4 4 0 1 1-3.845-.287L8.975 12 4.338 9.64a3.986 3.986 0 0 1-.38-.2ZM4 6a2 2 0 1 1 1.193 1.83l-.196-.1A2 2 0 0 1 4 6Zm.997 10.27a2 2 0 1 0 .197-.1l-.197.1Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M16.5 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM22 11a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H22Z", fill: "currentColor" })] }))); };
exports.default = SvgScissorsCut02;
